/**
 * Checks if browser is Chrome or not and returns true/false as to whether we should use SDK or not
 *
 * @returns boolean
 */

export const useSpeechSDK = () => {
  // IE11 now returns undefined again for window.chrome
  // Opera 30 outputs true for window.chrome but needs to check if window.opr is not undefined
  // new IE Edge outputs to true now for window.chrome
  // let isChromium = window.chrome;
  // let winNav = window.navigator;
  // let vendorName = winNav.vendor;
  // let isOpera = typeof window.opr !== 'undefined';
  // let isIEedge = winNav.userAgent.indexOf('Edg') > -1;
  // let isIOSChrome = winNav.userAgent.match('CriOS');

  //Leaving this here just in case.. 02/07/2022
  // const isSafari() =
  //   navigator.vendor &&
  //   navigator.vendor.indexOf('Apple') > -1 &&
  //   navigator.userAgent &&
  //   navigator.userAgent.indexOf('CriOS') == -1 &&
  //   navigator.userAgent.indexOf('FxiOS') == -1;

  //Leaving in for now in case Azure costs too much and we need to bring this back.
  // if (isIOSChrome) {
  //   //Is Google Chrome on IOS
  //   // console.log('Chrome IOS')
  //   return true;
  // } else if (
  //   isChromium !== null &&
  //   typeof isChromium !== 'undefined' &&
  //   vendorName === 'Google Inc.' &&
  //   isOpera === false &&
  //   isIEedge === false
  // ) {
  //   //Is Google Chrome
  //   // console.log('Chrome')
  //   return false;
  // }

  //Always default to true as not all browsers have
  //built-in speech recognition so safer this way - just more expensive...
  // console.log('Not Chrome')
  return true;
};
